module.exports = __webpack_public_path__ + "media/application/images/2023/05_still-600x338-794167dafaaf6c840d8d45e3e67a60ae.png";